exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".providers .provider {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .providers .provider .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .providers .provider:hover {\n    cursor: pointer; }\n    .providers .provider:hover .item-actions {\n      opacity: 1; }\n  .providers .provider:hover {\n    background-color: #fcf9f3; }\n  .providers .provider .title {\n    font-weight: bold; }\n  .providers .provider .description {\n    color: #898a8e;\n    margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/providers/provider-list/provider-list.component.scss
// module id = 410
// module chunks = 0